import { useLayoutEffect, useRef, useState } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { logger } from '@zep/core-logger';
import { PenPaperIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
import { useQuizTitle } from '../features/build-quiz-title';
import { QUIZ_SET_TITLE_MAX_LENGTH } from '../form/schema';
const MAX_WIDTH = 280;
export const BuildHeaderTitleInput = () => {
  const {
    title,
    updateTitle,
    clearTitle,
    titlePlaceholder
  } = useQuizTitle();
  const hiddenSpanForWidthChange = useRef<HTMLSpanElement>(null);
  const [width, setWidth] = useState(0);
  // blur 마다가 아니라 실제로 값이 바뀐 편집에만 발화한다 — 포커스만 스치는
  // 케이스(예: 다른 버튼 클릭으로 인한 blur)의 오발화를 막는다.
  const titleOnFocusRef = useRef(title);

  //깜빡임을 방지하기 위해 layout effect 사용
  useLayoutEffect(() => {
    if (hiddenSpanForWidthChange.current) {
      setWidth(hiddenSpanForWidthChange.current.offsetWidth);
    }
  }, [title, titlePlaceholder]);
  return <div className="group relative flex h-[30px] min-w-0 items-center gap-2xs border-b border-transparent focus-within:!border-opacity-black-5 hover:border-opacity-black-3" style={{
    // 평상시 ellipsis되지 않도록 1px 미세 추가
    // FIXME: 언어에 따라 버퍼를 다르게 두어야 하는 경우가 있을 수 있다.
    width: width < MAX_WIDTH ? 'auto' : `${width + 1}px`,
    maxWidth: `${MAX_WIDTH}px`
  }} data-sentry-component="BuildHeaderTitleInput" data-sentry-source-file="BuildHeaderTitleInput.tsx">
      <input type="text" value={title} onChange={e => {
      const value = e.target.value;
      if (value === '') {
        clearTitle();
      } else {
        updateTitle(value);
      }
    }} className={cn('block overflow-hidden whitespace-nowrap text-left !ring-0 text-body-lg-bold placeholder:text-default group-focus-within:placeholder:text-assistive', 'text-ellipsis min-w-0')} placeholder={titlePlaceholder} maxLength={QUIZ_SET_TITLE_MAX_LENGTH} style={{
      width: `${width + 1}px`,
      maxWidth: `${MAX_WIDTH}px`
    }} onFocus={() => {
      titleOnFocusRef.current = title;
    }} onBlur={() => {
      if (title === titleOnFocusRef.current) return;
      logger.track('quiz_set_title_change', {
        location: 'build_header',
        title: title
      });
    }} />

      <span ref={hiddenSpanForWidthChange} className="invisible absolute block whitespace-pre text-body-lg-bold">
        {title.length > 0 ? title : titlePlaceholder}
      </span>

      <div className={cn('overflow-hidden transition-all duration-200 ease-in-out', 'w-0 opacity-0 shrink-0', 'group-hover:w-md group-hover:opacity-100', 'group-focus-within:!w-0 group-focus-within:!opacity-0')}>
        <PenPaperIcon fill={ICON_COLOR.neutral} size="xs" className="shrink-0" data-sentry-element="PenPaperIcon" data-sentry-source-file="BuildHeaderTitleInput.tsx" />
      </div>
    </div>;
};